import React, { useState } from 'react';

import ModalPopup from '../../common/ModalPopup/ModalPopup';

import './DeleteAircraftPopup.scss';

import SuccessPopup from '../SuccessPopup/SuccessPopup';

import { useTranslation } from "react-i18next";

import { DELETE_POPUP_DETAILS } from "../../../helper/constants";
import { Button_V2 } from '../../common/Button_V2';
 
const DeleteAircraftPopup = (props) => {

    const [showSuccessPopup, setShowSuccessPopup] = useState(false);

    const [successMessage, setSuccessMessage] = useState("");

    const [errorMessage, setErrorMessage] = useState("");

    const [isSuccess, setIsSuccess] = useState(false);

    const [isError, setIsError] = useState(false);

    const [isDisabled, setIsDisabled] = useState(false);

    const { t } = useTranslation();
 
    // WARNING ICON — inline SVG

    const warningIcon = () => (
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#FEE4E2"/>
<path d="M15.2554 6.52958C15.6703 6.34515 16.1364 6.32143 16.5641 6.45976L16.745 6.52958L16.8766 6.59583C17.1696 6.76302 17.37 7.00815 17.5148 7.21261C17.683 7.45007 17.8634 7.76365 18.0627 8.10779L25.6019 21.1309C25.8019 21.4764 25.9852 21.7899 26.1077 22.0547C26.2282 22.3152 26.3588 22.6658 26.3172 23.0654C26.2632 23.5823 25.9919 24.0524 25.5715 24.358C25.2466 24.5942 24.8779 24.6559 24.5921 24.6821C24.3015 24.7087 23.9386 24.708 23.5394 24.708H8.46006C8.06098 24.708 7.69784 24.7087 7.40733 24.6821C7.12159 24.6559 6.75283 24.5942 6.428 24.358C6.00768 24.0524 5.7372 23.5823 5.68321 23.0654C5.64154 22.6658 5.77218 22.3152 5.89268 22.0547C6.01519 21.7899 6.1976 21.4763 6.39756 21.1309L13.9377 8.10779C14.1369 7.76369 14.3174 7.45003 14.4855 7.21261C14.6511 6.9789 14.8892 6.6924 15.2554 6.52958ZM15.9814 8.2725C15.8734 8.42504 15.7412 8.65101 15.5239 9.02625L7.98472 22.0494C7.76663 22.4261 7.63566 22.6542 7.55682 22.8246C7.55234 22.8343 7.54894 22.8438 7.54519 22.8523C7.5544 22.8533 7.56413 22.8558 7.57473 22.8568C7.76163 22.874 8.02491 22.8747 8.46006 22.8747H23.5394C23.9748 22.8747 24.2378 22.874 24.4247 22.8568C24.4353 22.8558 24.4451 22.8533 24.4543 22.8523C24.4505 22.8439 24.448 22.8342 24.4435 22.8246C24.3647 22.6542 24.2338 22.4261 24.0156 22.0494L16.4755 9.02625C16.2583 8.65102 16.1261 8.42501 16.0181 8.2725C16.0119 8.2638 16.0048 8.25671 15.9993 8.24923C15.9939 8.25655 15.9874 8.26402 15.9814 8.2725ZM16.0091 19.6664C16.5153 19.6664 16.9257 20.0769 16.9258 20.583C16.9258 21.0893 16.5154 21.4997 16.0091 21.4997H16.0002C15.4939 21.4997 15.0835 21.0893 15.0835 20.583C15.0836 20.0769 15.494 19.6664 16.0002 19.6664H16.0091ZM15.0835 16.9164V13.2497C15.0836 12.7436 15.494 12.333 16.0002 12.333C16.5063 12.3332 16.9167 12.7436 16.9168 13.2497V16.9164C16.9168 17.4226 16.5063 17.8329 16.0002 17.833C15.4939 17.833 15.0835 17.4226 15.0835 16.9164Z" fill="#B42318"/>
</svg>

    );
 
    // CLOSE BUTTON

    const handleokChange = () => {

        props?.closepop();

    };
 
    // CLOSE AFTER SUCCESS/ERROR

    const handleClosePopup = () => {

        props?.closepop();

        setShowSuccessPopup(false);

    };
 
    // DELETE API

    const handleDeleteChange = async () => {

        setIsDisabled(true);

        try {

            const deleteEndPoint = "/api/techpub/v1/delete-user-hangars";

            const payload = { id: props?.deleteData.toString() };

            const response = await fetch(deleteEndPoint, {

                method: 'DELETE',

                headers: { 'Content-Type': 'application/json' },

                body: JSON.stringify(payload)

            });

            const data = await response.json();

            if (data?.message?.result?.successMessage) {

                setIsSuccess(true);

                setShowSuccessPopup(true);

                setSuccessMessage(data?.message?.result?.successMessage);

                props?.fetchHangarList();

                setIsError(false);

            } else if (data?.message?.result?.errorMessage) {

                setIsSuccess(false);

                setIsError(true);

                setShowSuccessPopup(true);

                setErrorMessage(data?.message?.result?.errorMessage);

                props?.fetchHangarList();

            }

        } catch (error) {

            console.log("error" + error);

        }

    };
 
    return (
<>

            {!showSuccessPopup &&
<ModalPopup

                    showPopup={props?.show}

                    size="lg"

                    arialabel="Message Popup"

                    centered="true"

                    modalClass="cls-deleteWrapper"

                    closeButton={false}

                    cancelPopup={props?.closepop}

                    body={
<>
<div className='row'>
<div className='col-12'>

                                    {/* Icon + Title + Custom X — all in same row */}
<div className='cls-deleteHeader'>
<div className='cls-warningIcon'>

                                            {warningIcon()}
</div>
<h3 className='cls-deleteTitle'>

                                            {t(DELETE_POPUP_DETAILS.TITLE)}
</h3>

                                        {/* Custom X close button */}
<button

                                            type="button"

                                            className="cls-customClose"

                                            onClick={() => handleokChange()}

                                            aria-label="Close"
>
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 1L15 15M15 1L1 15" stroke="#1E1E25" strokeWidth="2" strokeLinecap="round"/>
</svg>
</button>
</div>

                                    {/* Subtitle — indented to align with title */}
<p className='cls-deleteextraTitle'>

                                        {t(DELETE_POPUP_DETAILS.SUBTITLE)}
</p>
</div>
</div>
</>

                    }

                    footer={
    <div className='cls-deleteButton'>
        <Button_V2
            type="secondary"
            mode="default"
            size="medium"
            onClick={() => handleokChange()}
        >
            {t(DELETE_POPUP_DETAILS.NO)}
        </Button_V2>
        {/* <button
            type="button"
            className="cls-noDelete"
            onClick={() => handleokChange()}
        >
            {t(DELETE_POPUP_DETAILS.NO)}
        </button> */}
        {/* <button
            type="button"
            disabled={isDisabled}
            className={isDisabled ? "cls-deleteOkButton" : "cls-yesDelete"}
            onClick={handleDeleteChange}
        >
            {t(DELETE_POPUP_DETAILS.YES)}
        </button> */}
         <Button_V2
            type="primary"
            mode="default"
            size="medium"
            onClick={handleDeleteChange}
        >
            {t(DELETE_POPUP_DETAILS.YES)}
        </Button_V2>
    </div>
}

                />

            }

            {showSuccessPopup && (
<SuccessPopup

                    show={showSuccessPopup}

                    closePopup={handleClosePopup}

                    successMessage={successMessage}

                    errorMessage={errorMessage}

                    messageFlag={isSuccess}

                    fetchHangarList={props?.fetchHangarList}

                />

            )}
</>

    );

};
 
export default DeleteAircraftPopup;
 